"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ElementsSubjectToTransactionSanctionControlsRef = void 0;
const Field_type_1 = require("../../types/Field.type");
exports.ElementsSubjectToTransactionSanctionControlsRef = {
    priority: Number.MAX_VALUE,
    label: 'fields.enm.elements_subject_to_transaction_sanction_controls.label',
    fallbackLabel: 'Elements subject to transaction sanction screening',
    type: Field_type_1.FieldType.Enum,
    options: [
        { key: 'SENDING_PARTIES', label: 'fields.enm.elements_subject_to_transaction_sanction_controls.options.SENDING_PARTIES', fallbackLabel: 'Sending parties including their bank' },
        { key: 'RECEIVING_PARTIES', label: 'fields.enm.elements_subject_to_transaction_sanction_controls.options.RECEIVING_PARTIES', fallbackLabel: 'Receiving parties including their bank' },
        { key: 'OTHER', label: 'fields.enm.elements_subject_to_transaction_sanction_controls.options.OTHER', fallbackLabel: 'Other' },
    ],
    trackFieldValueWithAnalytics: false,
};
